import { PaneState } from 'components/shuttle/Shuttle';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import { MockService } from 'types/rest/mockServiceTypes';
import RecordingsShuttle from '../MockServices/MockServiceDetail/Messaging/Shuttle/RecordingsShuttle';
import {
  fetchAssignedRecordingsForTemplate,
  fetchAvailableRecordingsForTemplate,
  moveTemplateRecordingsThunk,
  updateTemplateRecordingShuttlePane,
} from '../../../../store/mockServiceTemplates/mockServiceTemplateDetail/mockServiceTemplateDetailActions';

interface TemplateRecordingsShuttleProps {
  disabled: boolean;
  template: MockService;
}

const TemplateRecordingsShuttle = ({ disabled, template }: TemplateRecordingsShuttleProps) => {
  const shuttleState = useSelector((state: ApplicationState) => state.mockServiceTemplateDetail.recordingShuttle);
  const dispatch = useDispatch();

  return (
    <RecordingsShuttle
      disabled={disabled}
      mockService={template}
      shuttleState={shuttleState}
      fetchAvailableRecordings={() => {
        dispatch(fetchAvailableRecordingsForTemplate(template));
      }}
      fetchAssignedRecordings={() => {
        dispatch(fetchAssignedRecordingsForTemplate(template));
      }}
      updateRecordingShuttlePane={(panePosition: 'LEFT' | 'RIGHT', state: PaneState) => {
        dispatch(updateTemplateRecordingShuttlePane(panePosition, state));
      }}
      moveRecordings={(position: 'LEFT' | 'RIGHT', recordingIds: number[]) => {
        dispatch(moveTemplateRecordingsThunk(position, template, recordingIds));
      }}
    />
  );
};

export default TemplateRecordingsShuttle;
